import { Component, Vue, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import PerformanceProgress from '@/components/charts/performance-bar/performance-bar';
import DountChart from '@/components/charts/dount-chart/dount-chart';
import { GroupsTimespent, TimespentData, ClassTimespentData, TimespentDrilldown, ClassTimespentDrilldown } from '@/models/groups/timespent';
import { appConfigService } from '@/providers/services/app/app-config';
import { getPercentage } from '@/helpers/number-format';
import { SubjectModel } from '@/models/groups/subjects';
import { DEMO_HIERARCHY_HEADS, DEMO_HIERARCHY_POPUP_HEADS } from '@/utils/constants';
@Component({
    name: 'drilldown-timespent-pullup',
    components: {
        'material-icon': GoogleMaterialIcon,
        'performance-bar': PerformanceProgress,
        'dount-chart': DountChart,
    },
})

export default class DrilldownTimespentPullup extends Vue {

    @Prop()
    private timespentData!: TimespentData;

    @Prop()
    private classTimespentData!: ClassTimespentData;

    @Prop()
    private groupType!: string;

    @Prop()
    private groupId!: string;

    @Prop()
    private isAtInitialLevel!: boolean;

    @Prop()
    private subjectData!: SubjectModel[];

    @Prop()
    private activeSubject: any;

    @Prop()
    private selectedSubject: any;

    private dataList?: any = [];

    private isShowMessage: boolean = false;

    private messageBoxStyle?: any = null;

    private enableRightScroll: boolean = false;

    private enableLeftScroll: boolean = false;

    private get averageTs() {
        return this.tsData ? this.tsData.overallStats.overallAverageTimespent : 0;
    }

    private get tsData() {
        return this.groupType === 'class' ? this.classTimespentData : this.timespentData;
    }

    private get subSelection() {
        return this.$access.isDemoGroup ? DEMO_HIERARCHY_POPUP_HEADS[this.tsData.type] : this.tsData.name;
    }

    get groupLabel() {
        const accessibleLevels = appConfigService.getUserGroupAccessLevel();
        const activeLevelIndex = accessibleLevels.findIndex((level: any) => level.type === this.tsData.type);
        if (this.$access.isDemoGroup) {
            return this.groupType === 'class'
                ? 'learners' : DEMO_HIERARCHY_POPUP_HEADS[accessibleLevels[activeLevelIndex + 1].type];
        }
        return this.groupType === 'class' ?
            'student' : activeLevelIndex >= 0 ?
                accessibleLevels[activeLevelIndex + 1] ?
                    accessibleLevels[activeLevelIndex + 1].name : this.tsData.type : this.tsData.type;
    }

    private get drilldownList() {
        return this.sortArray('overallAverageTimespent', this.tsData.drilldown).reverse();
    }

    private get maxDrilldownTs() {
        const drilldown: Array<TimespentDrilldown | ClassTimespentDrilldown> = this.tsData.drilldown;
        return Math.max.apply(Math, drilldown.map((drilldownItem: any) => drilldownItem.overallAverageTimespent));
    }

    @Prop({ default: false })
    private isRestrictClass!: boolean;

    // -----------------------------------------------------------------------
    // Actions

    private onGoBack() {
        this.$emit('onGoBack', false);
    }

    private onSelectLevel(drilldown: any) {
        this.$emit('onSelectLevel', drilldown, this.activeSubject, 'timespent');
    }

    private onGoupward() {
        this.$emit('onGoUpward', this.activeSubject, 'timespent');
    }

    private onShowMessage(event: any, index: any = 0) {
        this.isShowMessage = true;
        this.messageBoxStyle = {
            top: (event.pageY - 255) + 'px',
            left: (event.pageX - 150) + 'px',
        };
    }

    private onHideMessage() {
        this.isShowMessage = false;
    }

    private onSelectSubject(subject: any = null) {
        this.$emit('onSelectSubject', subject);
    }


    // ------------------------------------------------------------------------
    // Hooks
    private created() {
        window.scrollTo(0, 0);
    }

    private getPercentage(value: number, total: number) {
        return getPercentage(value, total);
    }

    private onSelectClassProgress(level: any) {
        this.$emit('onSelectClassProgress', level);
    }

    private mounted() {
        this.onScrollActions();
    }

    // --------------------------------------------------------------------------
    // Methods

    private sortArray(key: string = 'fullName', list: any[] = []) {
        return list.sort((a: any, b: any) => {
            if (a[key] < b[key]) { return -1; }
            if (a[key] > b[key]) { return 1; }
            return 0;
        });
    }

    private onScrollActions() {
        const bodyContainer: null | any = this.$el.querySelector('.avg-session-nav-tab-panel');
        if (bodyContainer.scrollWidth > bodyContainer.clientWidth) {
            this.enableRightScroll = true;
        }
        let startPosition = bodyContainer.scrollLeft;
        bodyContainer.onscroll = () => {
            if (bodyContainer.scrollLeft > startPosition) {
                this.enableLeftScroll = true;
                const clientWidth = bodyContainer.scrollWidth - bodyContainer.scrollLeft;
                if (clientWidth === bodyContainer.clientWidth) { this.enableRightScroll = false; }
            }
            if (bodyContainer.scrollLeft < startPosition) {
                this.enableRightScroll = true;
                if (bodyContainer.scrollLeft === 0) { this.enableLeftScroll = false; }
            }
            startPosition = bodyContainer.scrollLeft;
        };
    }

    private scollWithButtons(action: any) {
        const bodyContainer: null | any = this.$el.querySelector('.avg-session-nav-tab-panel');
        if (action === 'Right') {
            bodyContainer.scrollLeft += 150;
            this.enableLeftScroll = true;
            const clientWidth = bodyContainer.scrollWidth - bodyContainer.scrollLeft;
            if (clientWidth === bodyContainer.clientWidth) { this.enableRightScroll = false; }
        }
        if (action === 'Left') {
            bodyContainer.scrollLeft -= 150;
            this.enableRightScroll = true;
            if (bodyContainer.scrollLeft === 0) { this.enableLeftScroll = false; }
        }
    }


}
